import {Component, Inject, OnInit} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AppConfigService } from '../app-config.service';

@Component({
    selector: 'app-qr-scanner-dialog',
    templateUrl: './qr-scanner.component.html',
    styleUrls: ['./qr-scanner.component.css']
})
export class QrScannerComponent implements OnInit {
    hasPermission: boolean | null = null;
    devices: MediaDeviceInfo[] = [];
    selectedDevice: MediaDeviceInfo | null = null;
    private currentIndex = 0; // Índice de la cámara activa
    colorBtn: string;


    constructor(
        public dialogRef: MatDialogRef<QrScannerComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private appConfigService: AppConfigService,
    ) {}

    ngOnInit(): void {
        this.colorBtn = this.appConfigService.getConfig().colorBtn
        // 1️⃣ Pide permiso desde el inicio
        navigator.mediaDevices.getUserMedia({ video: true })
            .then(stream => {
                this.hasPermission = true;

                // Detén inmediatamente el stream; sólo queríamos el permiso
                stream.getTracks().forEach(track => track.stop());

                // 2️⃣ Ahora enumera dispositivos
                return navigator.mediaDevices.enumerateDevices();
            })
            .then(devices => {
                this.devices = devices.filter(d => d.kind === 'videoinput');

                // Buscar trasera (back)
                const backCam = this.devices.find(d =>
                    /back|rear|environment/i.test(d.label)
                );

                this.selectedDevice = backCam || this.devices[0] || null;
                this.currentIndex = this.devices.indexOf(this.selectedDevice!);
            })
            .catch(err => {
                this.hasPermission = false;
                console.error('No se concedió permiso o hubo un error:', err);
            });
    }

    toggleCamera(): void {
        if (!this.devices.length) { return; }

        // Avanzar índice (y envolver al inicio)
        this.currentIndex = (this.currentIndex + 1) % this.devices.length;
        this.selectedDevice = this.devices[this.currentIndex];
    }

    onScanSuccess(result: string): void {
        this.dialogRef.close(result);  // Cierra el diálogo y devuelve el resultado
    }

    onHasPermission(has: boolean): void {
        this.hasPermission = has;
    }

    closeDialog(): void {
        this.dialogRef.close();  // Cierra sin resultado
    }
}
